import React from "react";
import NavBar from "../NavBar/NavBar";
import axios from "axios";
import TableViewHeader from "../TableView/TableViewHeader";
import TableViewTextCell from "../TableView/TableViewTextCell";
import TableViewDropdownCell from "../TableView/TableViewDropdownCell";
import { REACT_APP_MAIL_SERVICE_BASE_URL } from "../data/Constants";
import LoadingView from "../Reusable Views/LoadingView";
import { withAuth0 } from "@auth0/auth0-react";
import { withLocalizationHook } from "src/Localization";

class ProfileForm extends React.Component {
	state = {
		gender: "-",
		first_name: "",
		last_name: "",
		zip: "",
		company: "",
		email: "",
		newsletter: true,
		isLoading: true,
		isSending: false,
	};

	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleToggleChange = this.handleToggleChange.bind(this);
		this.sendForm = this.sendForm.bind(this);
	}

	componentDidMount() {
		this.loadUserMetadata();
	}

	async loadUserMetadata() {
		let auth0 = this.props.auth0;

		// Get an access token from auth0 and use it to load the user details.

		try {
			const accessToken = await auth0.getAccessTokenSilently();

			const userDetailsByIdUrl =
				"https://" +
				REACT_APP_MAIL_SERVICE_BASE_URL +
				"/api/v2/users/" +
				auth0.user.sub;

			const metadataResponse = await fetch(userDetailsByIdUrl, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			});

			let response = await metadataResponse.json();
			const { user_metadata } = response;

			this.setState({
				isLoading: false,
				gender: user_metadata.gender ?? "-",
				first_name: user_metadata.first_name ?? "",
				last_name: user_metadata.last_name ?? "",
				zip: user_metadata.zip ?? "",
				company: user_metadata.company ?? "",
				email: response.email ?? "",
				newsletter: user_metadata.newsletter ?? false,
			});
		} catch (e) {
			console.log(e.message);
		}
	}

	handleChange(event) {
		const value = event.target.value;
		this.setState({
			...this.state,
			[event.target.name]: value,
		});
	}

	handleToggleChange(checked) {
		// Important: API expects a string value instead of a boolean.
		this.setState({
			newsletter: checked === true ? "true" : "false",
		});
	}

	async sendForm() {
		let auth0 = this.props.auth0;

		this.setState({ isSending: true });

		// Get an access token from auth0 and use it so patch the updated user data.

		try {
			const accessToken = await auth0.getAccessTokenSilently();

			axios.defaults.headers.common.Accept = "application/json";
			axios.defaults.headers.common.Authorization = "Bearer " + accessToken;

			let data = {
				email: this.state.email,
				user_metadata: {
					first_name: this.state.first_name,
					last_name: this.state.last_name,
					gender: this.state.gender,
					zip: this.state.zip,
					company: this.state.company,
					newsletter: this.state.newsletter,
				},
			};

			axios
				.patch(
					"https://" +
						REACT_APP_MAIL_SERVICE_BASE_URL +
						"/api/v2/users/" +
						auth0.user.sub,
					data
				)
				.then(() => {
					this.setState({ isSending: false });
					auth0.loginWithRedirect();
				})
				.catch((error) => {
					console.log(error);
					this.setState({ isSending: false });
				});
		} catch (e) {
			console.log(e);
		}
	}

	GenderOptions() {
		const { t } = this.props.localizationHook;
		return [
			<option key="-" value="-">
				{t.salutations.default}
			</option>,

			<option key="male" value="m">
				{t.salutations.m}
			</option>,
			<option key="female" value="w">
				{t.salutations.f}
			</option>,
			<option key="diverse" value="d">
				{t.salutations.d}
			</option>,
		];
	}

	Form() {
		const { t } = this.props.localizationHook;

		return (
			<div>
				<TableViewHeader title={t.forms.personal_info} />
				<TableViewDropdownCell
					name="gender"
					label={t.forms.salutation}
					value={this.state.gender}
					items={this.GenderOptions()}
					onChange={this.handleChange}
				/>
				<TableViewTextCell
					name="first_name"
					label={t.forms.firstname}
					text={this.state.first_name}
					onChange={this.handleChange}
				/>
				<TableViewTextCell
					name="last_name"
					label={t.forms.lastname}
					text={this.state.last_name}
					onChange={this.handleChange}
				/>

				<TableViewHeader title={t.forms.email} />
				<TableViewTextCell
					name="email"
					label={t.forms.email}
					text={this.state.email}
					onChange={this.handleChange}
				/>

				<TableViewHeader title={t.forms.company_req} />
				<TableViewTextCell
					name="company"
					label={t.forms.company}
					placeholder={t.forms.company_req}
					text={this.state.company}
					onChange={this.handleChange}
				/>
				<TableViewTextCell
					name="zip"
					label={t.forms.zip}
					placeholder={t.forms.zip_req}
					text={this.state.zip}
					onChange={this.handleChange}
				/>
			</div>
		);
	}

	render() {
		let auth0 = this.props.auth0;
		const { t } = this.props.localizationHook;

		return (
			<div className="content">
				<NavBar
					title={t.forms.profile}
					backButtonTitle={t.general.back}
					rightBarButtonItemTitle={t.general.save}
					rightBarButtonIsConfirm={true}
					rightBarButtonItemAction={this.sendForm}
					disableRightBarButtonItem={
						this.state.first_name.length === 0 ||
						this.state.last_name.length === 0 ||
						this.state.gender.length === 0
					}
				/>

				{this.state.isSending || auth0.isLoading || this.state.isLoading ? (
					<LoadingView />
				) : (
					this.Form()
				)}
			</div>
		);
	}
}

export default withAuth0(withLocalizationHook(ProfileForm));
